var _g, _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAllFavoriteGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#all_favorite_grey_svg__clip0_13870_6011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0c13.255 0 24 10.745 24 24S37.255 48 24 48 0 37.255 0 24 10.745 0 24 0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#all_favorite_grey_svg__clip1_13870_6011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.766 26.99l-3.82 4.293.59-7.048 15.887-9.27-12.657 12.024z",
    fill: "#D6D7E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.819 29.547l3.33-8.821-6.185 5.79-4.018 4.767 6.873-1.736z",
    fill: "#C2C1CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.422 14.964c-3.205 2.093-10.098 6.566-14.088 9.061-2.256 1.409-6.039-.293-7.074-3.283C12.224 17.752 14.464 14 17.022 14H32.73c.775 0 1.357.42 1.695.964",
    fill: "#EDF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.398 14.901c.445.44.721 1.086.548 1.808L31.44 31.325c-.57 2.377-4.687 3.568-7.34 1.89-2.652-1.676-3.448-5.605-1.587-7.366 3.296-3.12 9.145-8.465 11.88-10.948",
    fill: "#EDF0F3"
  })), /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#000",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.05,
    d: "M.5.5h47v47H.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 24C.5 11.021 11.021.5 24 .5S47.5 11.021 47.5 24 36.979 47.5 24 47.5.5 36.979.5 24z",
    stroke: "#000",
    strokeOpacity: 0.05
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "all_favorite_grey_svg__clip0_13870_6011"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0c13.255 0 24 10.745 24 24S37.255 48 24 48 0 37.255 0 24 10.745 0 24 0z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "all_favorite_grey_svg__clip1_13870_6011"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(13 14)",
    d: "M0 0h22v20H0z"
  })))));
}

export default SvgAllFavoriteGrey;